import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../Components/style/home.css';
import '../../Components/style/text.css';
import '../../Components/style/signin.css';
import MetaTags from '../../Components/meta';
import { Spin, notification } from 'antd';
import { IndicatorCustomized } from '../../Components/spining';
import { firebase } from '../../base';
import { getAuth, signInWithPopup, GoogleAuthProvider, signInWithEmailAndPassword } from "firebase/auth";


export default function Signin() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = (event) => {
        event.preventDefault();
        loginEmail();
    };

    const handleGoogle = async () => {
        await loginGoogle();
    }

    const loginEmail = async () => {
        setLoading(true);
        const auth = firebase.auth();
        await signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                const user = userCredential.user;
                navigate('/admin');
            })
            .catch((error) => {
                notification.error({
                    message: <p className='title-small'>Invalid Credentials</p>,
                    description: <p className='text-small'>The email or password you entered is incorrect.</p>,
                    placement: 'top'
                });
            }).finally(() => {
                setLoading(false);
            });
    }


    const loginGoogle = async () => {
        setLoading(true);
        const auth = firebase.auth();
        const provider = new GoogleAuthProvider();
        await signInWithPopup(auth, provider)
            .then((result) => {
                const user = result.user;
                checkUser(auth, user.uid);
            })
            .catch((error) => {
                notification.error({
                    message: <p className='title-small'>Login Error</p>,
                    description: error.message,
                    placement: 'top'
                });
            }).finally(() => {
                setLoading(false);
            });
    }

    const checkUser = async(auth, userID) => {
        const userRef = firebase.firestore().collection('userinfo').doc(userID); // ou 'user.email'
        const userDoc = await userRef.get();

        if (userDoc.exists) {
            navigate('/admin');
        } else {
            notification.error({
                message: <p className='title-small'>Unauthorized</p>,
                description: <p className='text-small'>Your account is not authorized to access this system.</p>,
                placement: 'top'
            });
            auth.signOut();
        }
    }

    return (
        <>
            <MetaTags
                title="Institute Nilia | Sign In"
                description="Sign in to your account to continue."
                image={require('../../assets/icons/nilia.webp')}
                name="Institute Nilia"
            />
            <Spin indicator={<IndicatorCustomized />} spinning={loading}>
                <div className="body-container items-center justify-center">
                    <div className="card-login">
                        <img src={require('../../assets/icons/nilia.webp')} alt="Nyikela Mali" className='logo-login' onClick={() => navigate('/')} />
                        <p className='title-normal'>Welcome Back!</p>
                        <p className='text-normal'>Sign in to your account to continue.</p>
                        <div className='grid grid-cols-1 gap-3 w-full'>
                            <div className='button-social' onClick={handleGoogle}>
                                <img src={require('../../assets/icons/google.png')} alt="Google" className='social-icon' />
                                <p className='text-normal'>Google</p>
                            </div>
                        </div>
                        <div className='divider'>
                            <hr className='divider-line' />
                            <p className='text-small' style={{ marginBottom: 0 }}>
                                Or
                            </p>
                            <hr className='divider-line' />
                        </div>
                        <form className='form-login' onSubmit={handleSubmit}>
                            <div className='form-group'>
                                <label className='text-small'>Email</label>
                                <input
                                    type="email"
                                    className='input-login'
                                    placeholder='Enter your email'
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                            <div className='form-group'>
                                <label className='text-small'>Password</label>
                                <input
                                    type="password"
                                    className='input-login'
                                    placeholder='Enter your password'
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>
                            <button type='submit' className='btn-login'>
                                Sign In
                            </button>
                        </form>
                    </div>
                </div>
            </Spin>
        </>
    );
}
